var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppointmentStats = function SvgAppointmentStats(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 25.3333H7.16667V10.6667H25.8333M21.8333 1.33333V4H11.1667V1.33333H8.5V4H7.16667C5.68667 4 4.5 5.18667 4.5 6.66667V25.3333C4.5 26.0406 4.78095 26.7189 5.28105 27.219C5.78115 27.719 6.45942 28 7.16667 28H25.8333C26.5406 28 27.2189 27.719 27.719 27.219C28.219 26.7189 28.5 26.0406 28.5 25.3333V6.66667C28.5 5.95942 28.219 5.28115 27.719 4.78105C27.2189 4.28095 26.5406 4 25.8333 4H24.5V1.33333M23.1667 16H16.5V22.6667H23.1667V16Z",
    fill: "#F89377"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppointmentStats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AppointmentStats.47eb5f28816350fb7efa935d01541630.svg";